import { DmsAction, CommonAction } from 'Actions/index';
import { DmsActionTypes, CommonActionTypes } from 'Actions/ActionTypes/index';
import { IDmses } from 'Store/IDmses';
import Util from 'Util/index';
import equal from 'fast-deep-equal';

/**
 * An empty array of DMS objects.
 */
const initialState: IDmses = {};

/**
 * A function that maps DMSes from a invoked action to the current state.
 * @param state - The current state.
 * @param action - The action invoked by store.
 */
export const dmses = (state: IDmses = initialState, action: DmsAction | CommonAction) => {
    let newState: IDmses;

    switch (action.type) {
        case DmsActionTypes.AddDmses:
            newState = { ...state };
            action.dmses.forEach(dms => {
                newState[Util.IdToString(dms.id!)] = dms;
            });
            break;
        case DmsActionTypes.ModifyDmses:
            newState = { ...state };
            // eslint-disable-next-line no-case-declarations
            let changed = false;
            action.dmses.forEach(dms => {
                console.log(action.type, dms.id!);
                // Bug: intOpStatus sometimes doesn't match opStatus causing unnecessary updates.
                // if (newState[Util.IdToString(dms.id!)].status!.opStatus === dms.status!.opStatus) {
                //    dms.status!.intOpStatus = newState[Util.IdToString(dms.id!)].status!.intOpStatus;
                // }
                if (!equal(newState[Util.IdToString(dms.id!)], dms)) {
                    console.log('Change Detected', action.type);
                    console.log('Old DMS Comm', JSON.stringify(newState[Util.IdToString(dms.id!)].dmsComm?.opStatus));
                    console.log('New DMS Comm', JSON.stringify(dms.dmsComm?.opStatus));
                    console.log('Old DMS Status', JSON.stringify(newState[Util.IdToString(dms.id!)].status?.intOpStatus));
                    console.log('New DMS Status', JSON.stringify(dms.status?.intOpStatus));
                    newState[Util.IdToString(dms.id!)] = dms;
                    changed = true;
                }
            });
            if (!changed) {
                newState = state;
            }
            break;
        case DmsActionTypes.DeleteDmses:
            newState = { ...state };
            action.ids.forEach(id => delete newState[Util.IdToString(id!)]);
            break;
        case CommonActionTypes.ClearStore:
            newState = initialState;
            break;
        default:
            newState = state;
    }

    return newState;
};
